export const keyFeature = [
    {name : "Loan Amount: Rs 20,000 to Rs 2,00,000"},
    {name: "Minimum Annual Percentage Rate (APR): 24%"},
    {name: "Maximum APR: 33% (reducing balance)"},
    {name: "Minimum repayment period: 3 months"},
    {name: "Maximum repayment period: 10 months"},
    {name: "Processing Fees: 2% (Max ₹2000 incl GST)"},
    {name: "Prepayment Fees: Nil"},
]

export const aboutApp = [
    {name : 'Instant Group Loan / Personal Loan (Rs 20,000 - Rs 2 Lakh) Low Intrest'},
    {name: "Get a personal loan of upto Rs. 2 Lakhs at affordable interest rates as Direct Cash transfer in Groups of at-least 3 People."},
    {name: "Kosh is a Loan App trusted by over 1 Lakh Indians. Avail secure group loans, personal loans, and Home Loans."},
    {name: "Repay your loans conveniently through flexible EMI options and improve your CIBIL score."},
    {name: "Take advantage of the user-friendly interface and completely paperless and online process toget cash quickly in your bank account."},
    {name: "Kosh has partnered with NBFCs, licensed by the Reserve Bank of India (RBI) and is totally secure."},
]

export const totalLoanCost = [
    {name: "✔ Amount Borrowed (Principal) = ₹20000/-"},
    {name: "✔ Interest Rate (APR) = 18% - 33%"},
    {name: "✔ Tenure = 10 months"},
    {name: "✔ Processing Fee = ₹400"},
    {name: "✔ Amount disbursed = ₹19,600"},
    {name: "✔ Your EMI amount = ₹2315 (sample monthly payment based on PMT method)"},
    {name: "✔ Interest amount = ₹2315 x 10 - ₹20000 = ₹3150 (sample interest calculation)"},
    {name: "✔ Total Cost of Loan (Including all applicable fees) = Processing Fee + Interest Amount + Principal = ₹400 + ₹3150 + ₹20000 = ₹23550"}
]

export const appFeature = [
    "Upto Rs 2,00,000 limit ",
    "Instant money transfer to bank account",
    "100% paperless process",
    "Minimal documentation",
    "Flexible loan and EMI amount options",
    "Instant eligibility check"
]

export const loanElegiblity = [
    "Indian citizen",
    "Age above 20 years",
    "Age below 65 Years"
]

export const docRequired = [
    "PAN number",
    "Aadhaar number",
    "Salary Slip / Employment Id"
]

export const applySteps = [
    "Install Kosh App",
    "Register using your mobile number",
    "Add your group members for Group Loan",
    "Fill your basic details to check your loan eligibility",
    "Choose the loan and EMI amount of your choice",
    "Complete the KYC with selfie and Aadhaar",
    "Enter bank details for money transfer",
    "Loan Approved and Disbursed"
]

export const opCities = [
"Delhi NCR: New Delhi, Gurgaon, Noida, Greater Noida, Faridabad",
"Himachal Pradesh: Shimla, Baddi, Parwanoo, Solan",
"Haryana: Chandigarh, Karnal, Panipat, Ambala, Sonipat, Kundli",
"Punjab: Amritsar, Ludhiana, Jalandhar, Mohali, Ropar, Bathinda, Fatehgarh Sahib",
"Rajasthan: Kota, Jaipur, Udaipur, Jodhpur, Neemrana",
"Uttar Pradesh: Mathura, Meerut, Agra",
"Uttarakhand: Haldwani, Haridwar",
"Madhya Pradesh: Jabalpur, Indore, Allahabad",
"Gujarat: Ahmedabad, Vadodara, Valsad"
]

export const loanAgainstProperty = 'Apply for loan against property from Kosh. Seamless process.'

export const loanDataSecurity = [
    "Your data is transferred over a secure HTTPS connection, and we do not share it with anyone without your consent. All the transactions are secured via a 128-bit SSL encryption.",

    "Our app requires some permissions to provide you a loan in a fast and easy manner. We need access to your User Account data such as name and email to auto fill your application and help you login. We also need access to your financial sms to enrich credit profile, auto read otp and give the best instant personal loan. We need access to your contacts for group creation. We need access to your location to verify your address. We require permission to access your contacts to get references for your loan application. For easy upload of documents in the app, we require access to Camera and Photo Gallery. We also need access to your device info to prevent misuse by any other individual."
]

export const appInfo = {
    "Version": "3.1.2",
    "Updated on": "16 Jan 2023",
    "Requires Android": "5.0 and up",
    "Downloads": "100,000+ downloads",
    "Content rating": "Rated for 3+ Learn more",
    "Permission": "View details",
    "Released on": "22 Aug 2019",
    "Offered by" : "Adhikosh Financial Advisory" 
}

export const patners = [
    "Anand Property Finance Limited (APFL)",
    "Capital Tradelinks Limited (Capital Tradelink)",
    "Mamta Projects Private Limited (Arthmate)"
]